export default {
    HEADER_CREATE_SCRIPT: "СОЗДАНИЕ СКРИПТА",
    HEADER_EDIT_SCRIPT: "РЕДАКТИРОВАНИЕ СКРИПТА",
    CANCEL: "Отменить",
    CREATE: "Создать",
    SAVE: "Сохранить",
    DELETE: "Удалить",
    NAME_PLACEHOLDER: "Введите название",
    NAME: "Название скрипта"
};
